<template>
  <div>
    <Layout ref="layoutRef" :selectedOption="1" />

    <!-- ── Breadcrumb ─────────────────────────────────────────────── -->
    <div class="mb-3 row">
      <div class="col-11">
        <nav aria-label="breadcrumb">
          <ol class="breadcrumb mb-0">
            <li class="breadcrumb-item">
              <router-link to="/tramite">Trámites</router-link>
            </li>
            <li class="breadcrumb-item">
              <router-link :to="{ name: 'TramiteForm', params: { idTramite: p_idtramite } }">
                Trámite N.° {{ p_idtramite }}
              </router-link>
            </li>
            <li class="breadcrumb-item">
              <router-link :to="{ name: 'TramiteForm',
                                  params: { p_idtramite },
                                  query: { tab: 'reportes' } }">
                Reportes
              </router-link>
            </li>
            <li class="breadcrumb-item active" aria-current="page">
              Resumen de Planillas
            </li>
          </ol>
        </nav>
      </div>
      <div class="col-1 text-end">
        <span
          class="material-symbols-outlined text-primary"
          style="font-size: 28px; cursor: pointer"
          @click="showModalHelp = true"
          title="Ayuda"
        >help</span>
      </div>
    </div>

    <hr />

    <!-- ── Info del trámite ───────────────────────────────────────── -->
    <div class="alert alert-info py-2 px-3 mb-3" role="alert" v-if="datosTramite">
      <span class="material-symbols-outlined align-middle me-1" style="font-size:18px">info</span>
      <strong>{{ datosTramite }}</strong>
    </div>

    <!-- ── Barra de acciones ──────────────────────────────────────── -->
    <div class="action-bar mb-3">
      <button
        class="action-btn action-btn--green"
        @click="exportarExcel"
        :disabled="datos.length === 0 || cargando"
        title="Exportar a Excel"
      >
        <span class="material-symbols-outlined">table_view</span>
        Exportar Excel
      </button>

      <!-- Filtro global -->
      <div class="d-flex align-items-center gap-1">
        <div class="filter-input-wrap">
          <span class="material-symbols-outlined filter-icon">search</span>
          <input
            type="text"
            class="filter-input"
            v-model="filtroTexto"
            placeholder="Buscar en todos los campos..."
            @input="paginar(1)"
          />
          <button
            v-if="filtroTexto"
            class="filter-clear"
            @click="filtroTexto = ''; paginar(1)"
            title="Limpiar filtro"
          >
            <span class="material-symbols-outlined" style="font-size:16px">close</span>
          </button>
        </div>
      </div>

      <!-- Filtro Diag 1 -->
      <div class="diag-autocomplete-wrap">
        <div class="filter-input-wrap">
          <span class="material-symbols-outlined filter-icon" style="font-size:16px">diagnosis</span>
          <input
            type="text"
            class="filter-input diag-input"
            v-model="filtroDiag1Input"
            placeholder="Diag 1..."
            @input="onDiag1Input"
            @focus="showDiag1List = true"
            @blur="hideDiagList('diag1')"
            autocomplete="off"
          />
          <button
            v-if="filtroDiag1Input"
            class="filter-clear"
            @click="limpiarDiag1"
            title="Limpiar Diag 1"
          >
            <span class="material-symbols-outlined" style="font-size:16px">close</span>
          </button>
        </div>
        <ul v-if="showDiag1List && sugerenciasDiag1.length" class="diag-suggestions">
          <li
            v-for="v in sugerenciasDiag1"
            :key="v"
            @mousedown.prevent="seleccionarDiag1(v)"
            :class="{ 'diag-selected': filtroDiag1 === v }"
          >{{ v }}</li>
        </ul>
      </div>

      <!-- Filtro Diag 2 -->
      <div class="diag-autocomplete-wrap">
        <div class="filter-input-wrap">
          <span class="material-symbols-outlined filter-icon" style="font-size:16px">diagnosis</span>
          <input
            type="text"
            class="filter-input diag-input"
            v-model="filtroDiag2Input"
            placeholder="Diag 2..."
            @input="onDiag2Input"
            @focus="showDiag2List = true"
            @blur="hideDiagList('diag2')"
            autocomplete="off"
          />
          <button
            v-if="filtroDiag2Input"
            class="filter-clear"
            @click="limpiarDiag2"
            title="Limpiar Diag 2"
          >
            <span class="material-symbols-outlined" style="font-size:16px">close</span>
          </button>
        </div>
        <ul v-if="showDiag2List && sugerenciasDiag2.length" class="diag-suggestions">
          <li
            v-for="v in sugerenciasDiag2"
            :key="v"
            @mousedown.prevent="seleccionarDiag2(v)"
            :class="{ 'diag-selected': filtroDiag2 === v }"
          >{{ v }}</li>
        </ul>
      </div>

      <!-- Selector registros por página -->
      <div class="ms-auto d-flex align-items-center gap-2">
        <label class="form-label mb-0 small fw-bold">Mostrar</label>
        <select
          v-model.number="elementosPorPagina"
          class="form-select form-select-sm"
          style="width: 75px;"
          @change="paginar(1)"
        >
          <option :value="10">10</option>
          <option :value="25">25</option>
          <option :value="50">50</option>
          <option :value="100">100</option>
        </select>
        <span class="small text-muted">registros</span>
      </div>
    </div>

    <!-- ── Spinner ────────────────────────────────────────────────── -->
    <div v-if="cargando" class="text-center py-4">
      <div class="spinner-border text-primary" role="status">
        <span class="visually-hidden">Cargando...</span>
      </div>
    </div>

    <!-- ── Tabla ──────────────────────────────────────────────────── -->
    <div class="table-responsive" v-if="datos.length > 0">
      <table class="table table-hover table-bordered table-sm">
        <thead class="table-dark">
          <tr>
            <th class="th-sort" @click="ordenarPor('numero')">
              Número <span class="sort-icon">{{ iconOrden('numero') }}</span>
            </th>
<th class="th-sort" @click="ordenarPor('fechaDesde')">
  Fecha Desde <span class="sort-icon">{{ iconOrden('fechaDesde') }}</span>
</th>
<th class="th-sort" @click="ordenarPor('fechaHasta')">
  Fecha Hasta <span class="sort-icon">{{ iconOrden('fechaHasta') }}</span>
</th>
            <th class="th-sort" @click="ordenarPor('cedulaPaciente')">
              Cédula <span class="sort-icon">{{ iconOrden('cedulaPaciente') }}</span>
            </th>
            <th class="th-sort" @click="ordenarPor('nombrePaciente')">
              Nombre Paciente <span class="sort-icon">{{ iconOrden('nombrePaciente') }}</span>
            </th>
            <th class="th-sort" @click="ordenarPor('diag1')">
              Diag 1 <span class="sort-icon">{{ iconOrden('diag1') }}</span>
            </th>
            <th class="th-sort" @click="ordenarPor('diag2')">
              Diag 2 <span class="sort-icon">{{ iconOrden('diag2') }}</span>
            </th>
            <th class="th-sort" @click="ordenarPor('cedulaMedico')">
              Cédula Médico <span class="sort-icon">{{ iconOrden('cedulaMedico') }}</span>
            </th>
            <th class="th-sort" @click="ordenarPor('nombreMedico')">
              Nombre Médico <span class="sort-icon">{{ iconOrden('nombreMedico') }}</span>
            </th>
            <th class="th-sort" @click="ordenarPor('especialidad')">
              Especialidad <span class="sort-icon">{{ iconOrden('especialidad') }}</span>
            </th>
<th class="th-sort" @click="ordenarPor('consulta')">
  Consulta <span class="sort-icon">{{ iconOrden('consulta') }}</span>
</th>
<th class="th-sort" @click="ordenarPor('valorConsulta')">
  Valor Consulta <span class="sort-icon">{{ iconOrden('valorConsulta') }}</span>
</th>
            <th class="th-sort text-end" @click="ordenarPor('totalLaboratorio')">
              Laboratorio <span class="sort-icon">{{ iconOrden('totalLaboratorio') }}</span>
            </th>
            <th class="th-sort text-end" @click="ordenarPor('totalImagen')">
              Imagen <span class="sort-icon">{{ iconOrden('totalImagen') }}</span>
            </th>
            <th class="th-sort text-end" @click="ordenarPor('totalMedicamentos')">
              Medicamentos <span class="sort-icon">{{ iconOrden('totalMedicamentos') }}</span>
            </th>
            <th class="th-sort text-end" @click="ordenarPor('totalInsumos')">
              Insumos <span class="sort-icon">{{ iconOrden('totalInsumos') }}</span>
            </th>
            <th class="th-sort text-end" @click="ordenarPor('totalGeneral')">
              Total General <span class="sort-icon">{{ iconOrden('totalGeneral') }}</span>
            </th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="d in datosPaginados" :key="d.idPlanilla" @dblclick="abrirPlanillaPopup(d.idPlanilla)">
            <td>{{ d.numero }}</td>
<td>{{ d.fechaDesde }}</td>
<td>{{ d.fechaHasta }}</td>
            <td>{{ d.cedulaPaciente }}</td>
            <td>{{ d.nombrePaciente }}</td>
            <td>{{ d.diag1 }}</td>
            <td>{{ d.diag2 }}</td>
            <td>{{ d.cedulaMedico }}</td>
            <td>{{ d.nombreMedico }}</td>
            <td>{{ d.especialidad }}</td>
<td>
  <span v-if="d.consulta" class="badge bg-info text-dark">{{ d.consulta }}</span>
  <span v-else class="text-muted small">—</span>
</td>
            <td class="text-end">{{ fmt(d.valorConsulta) }}</td>
            <td class="text-end">{{ fmt(d.totalLaboratorio) }}</td>
            <td class="text-end">{{ fmt(d.totalImagen) }}</td>
            <td class="text-end">{{ fmt(d.totalMedicamentos) }}</td>
            <td class="text-end">{{ fmt(d.totalInsumos) }}</td>
            <td class="text-end fw-bold">{{ fmt(d.totalGeneral) }}</td>
          </tr>
        </tbody>
        <tfoot>
          <tr class="table-secondary fw-bold">
            <td colspan="11" class="text-end small">TOTALES</td>
            <td class="text-end">{{ fmt(sumaCol('valorConsulta')) }}</td>
            <td class="text-end">{{ fmt(sumaCol('totalLaboratorio')) }}</td>
            <td class="text-end">{{ fmt(sumaCol('totalImagen')) }}</td>
            <td class="text-end">{{ fmt(sumaCol('totalMedicamentos')) }}</td>
            <td class="text-end">{{ fmt(sumaCol('totalInsumos')) }}</td>
            <td class="text-end">{{ fmt(sumaCol('totalGeneral')) }}</td>
          </tr>
          <tr class="table-secondary">
            <td colspan="17" class="text-end small">
              Mostrando {{ datosPaginados.length }} de {{ datosFiltradosOrdenados.length }} registros{{ filtroTexto ? ' (filtrados de ' + datos.length + ' totales)' : '' }}
            </td>
          </tr>
        </tfoot>
      </table>
    </div>

    <!-- ── Sin resultados ─────────────────────────────────────────── -->
    <div v-if="datos.length === 0 && !cargando" class="alert alert-warning mt-3" role="alert">
      No se encontraron registros para este trámite.
    </div>

    <!-- ── Paginación ─────────────────────────────────────────────── -->
    <div class="d-flex justify-content-between align-items-center mt-2" v-if="datos.length > 0">
      <span class="small text-muted">
        Página {{ paginaActual }} de {{ totalPaginas }} — {{ datos.length }} registros
      </span>
      <nav aria-label="Paginación">
        <ul class="pagination pagination-sm mb-0">
          <li class="page-item" :class="{ disabled: paginaActual === 1 }">
            <a class="page-link" href="#" @click.prevent="paginar(1)">«</a>
          </li>
          <li class="page-item" :class="{ disabled: paginaActual === 1 }">
            <a class="page-link" href="#" @click.prevent="paginar(paginaActual - 1)">‹</a>
          </li>
          <li class="page-item active">
            <span class="page-link">{{ paginaActual }}</span>
          </li>
          <li class="page-item" :class="{ disabled: paginaActual === totalPaginas }">
            <a class="page-link" href="#" @click.prevent="paginar(paginaActual + 1)">›</a>
          </li>
          <li class="page-item" :class="{ disabled: paginaActual === totalPaginas }">
            <a class="page-link" href="#" @click.prevent="paginar(totalPaginas)">»</a>
          </li>
        </ul>
      </nav>
    </div>

    <!-- ══════════════════════════════════════════════════════════════
         MODAL AYUDA
    ═══════════════════════════════════════════════════════════════ -->
    <div v-if="showModalHelp" class="modal fade show d-block" tabindex="-1" aria-modal="true">
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-header bg-primary">
            <span class="material-symbols-outlined text-white me-2" style="font-size:20px">help</span>
            <h5 class="modal-title text-white">Ayuda — Resumen de Planillas</h5>
            <button type="button" class="btn-close btn-close-white" @click="showModalHelp = false" />
          </div>
          <div class="modal-body">
            <p>
              Este reporte muestra un resumen financiero de las planillas asociadas al trámite,
              desglosando los importes por categoría de servicio.
            </p>
            <ul>
              <li><strong>Laboratorio</strong> — servicios con código <code>01.04.01%</code></li>
              <li><strong>Imagen</strong> — servicios con código <code>01.04.02%</code></li>
              <li><strong>Medicamentos</strong> — clase <code>7</code></li>
              <li><strong>Insumos</strong> — clase <code>8</code></li>
            </ul>
            <p class="text-muted small mb-0">
              Los totales del pie de tabla corresponden a todos los registros, no solo la página visible.
            </p>
          </div>
          <div class="modal-footer">
            <button class="btn btn-secondary" @click="showModalHelp = false">Cerrar</button>
          </div>
        </div>
      </div>
    </div>
    <div
      v-if="showModalHelp"
      class="modal-backdrop fade show"
      @click="showModalHelp = false"
    />

    <Footer />
  </div>
</template>

<script>
import Layout from "@/components/Layout.vue";
import Footer from "@/components/Footer.vue";
import api    from "@/services/api";
import Swal   from "sweetalert2";
import { abrirPlanillaPopup } from "@/assets/js/popup.js";

export default {
  name: "PlanillaResumen",
  components: { Layout, Footer },

  props: {
    p_idtramite: { type: Number, required: true },
  },

  data() {
    return {
      datos:              [],
      datosPaginados:     [],
      paginaActual:       1,
      elementosPorPagina: 25,
      cargando:           false,
      datosTramite:       "",
      showModalHelp:      false,
      filtroTexto:        "",
      filtroDiag1Input:   "",
      filtroDiag2Input:   "",
      showDiag1List:      false,
      showDiag2List:      false,
      campoOrden:         "numero",
      ascendente:         true,
    };
  },

  computed: {
datosFiltradosOrdenados() {
    let lista = [...this.datos];

    // 1. Filtro de Texto Global
    const texto = this.filtroTexto.toLowerCase().trim();
    if (texto) {
      lista = lista.filter(d =>
        [d.numero, d.cedulaPaciente, d.nombrePaciente, d.diag1, d.diag2,
         d.cedulaMedico, d.nombreMedico, d.especialidad,
 d.fechaDesde, d.fechaHasta, d.consulta]
          .some(v => (v ?? "").toString().toLowerCase().includes(texto))
      );
    }

// 2. Filtro de Diagnóstico 1 (Búsqueda parcial/reactiva)
if (this.filtroDiag1Input) {
  const f1 = this.filtroDiag1Input.toUpperCase().trim();
  lista = lista.filter(d => 
    (d.diag1 ?? "").toUpperCase().includes(f1)
  );
}

// 3. Filtro de Diagnóstico 2 (Búsqueda parcial/reactiva)
if (this.filtroDiag2Input) {
  const f2 = this.filtroDiag2Input.toUpperCase().trim();
  lista = lista.filter(d => 
    (d.diag2 ?? "").toUpperCase().includes(f2)
  );
}

    // 4. Ordenamiento (mantenemos tu lógica actual)
    const campo = this.campoOrden;
    const numCampos = ["valorConsulta","totalLaboratorio","totalImagen","totalMedicamentos","totalInsumos","totalGeneral"];
    
    lista.sort((a, b) => {
      let va = a[campo] ?? "";
      let vb = b[campo] ?? "";
      let cmp;
      if (numCampos.includes(campo)) {
        cmp = Number(va) - Number(vb);
      } else {
        cmp = String(va).localeCompare(String(vb), "es");
      }
      return this.ascendente ? cmp : -cmp;
    });

    return lista;
  },
    valoresDiag1() {
      return [...new Set(this.datos.map(d => d.diag1).filter(Boolean))].sort();
    },
    valoresDiag2() {
      return [...new Set(this.datos.map(d => d.diag2).filter(Boolean))].sort();
    },
    sugerenciasDiag1() {
      const t = this.filtroDiag1Input.toUpperCase().trim();
      if (!t) return this.valoresDiag1.slice(0, 20);
      return this.valoresDiag1.filter(v => v.toUpperCase().includes(t)).slice(0, 20);
    },
    sugerenciasDiag2() {
      const t = this.filtroDiag2Input.toUpperCase().trim();
      if (!t) return this.valoresDiag2.slice(0, 20);
      return this.valoresDiag2.filter(v => v.toUpperCase().includes(t)).slice(0, 20);
    },
    totalPaginas() {
      return Math.max(1, Math.ceil(this.datosFiltradosOrdenados.length / this.elementosPorPagina));
    },
  },

  async mounted() {
    this.$refs.layoutRef.toggleProcesos();
    this.$refs.layoutRef.toggleReportes();
    this.$refs.layoutRef.toggleParametros();
    this.$refs.layoutRef.toggleAyuda();
    this.datosTramite = sessionStorage.getItem("datosTramite");
    this.cargarDatos();
  },

  watch: {
    p_idtramite() { this.cargarDatos(); },
  },

  methods: {
    // ── Carga de datos ────────────────────────────────────────────
    async cargarDatos() {
      this.cargando    = true;
      this.datos       = [];
      this.filtroDiag1       = "";
      this.filtroDiag2       = "";
      this.filtroDiag1Input  = "";
      this.filtroDiag2Input  = "";
      try {
        const r    = await api.get(`/planilla-resumen/${this.p_idtramite}`);
        this.datos = r.data;
        this.paginar(1);
      } catch {
        Swal.fire({ icon: "error", title: "Error", text: "No se pudieron cargar los datos del resumen." });
      } finally {
        this.cargando = false;
      }
    },

    // ── Paginación ────────────────────────────────────────────────
    paginar(n) {
      this.paginaActual   = Math.max(1, Math.min(n, this.totalPaginas));
      const ini           = (this.paginaActual - 1) * this.elementosPorPagina;
      this.datosPaginados = this.datosFiltradosOrdenados.slice(ini, ini + this.elementosPorPagina);
    },

    // ── Totales de columna (sobre todos los datos) ────────────────
    sumaCol(campo) {
      return this.datosFiltradosOrdenados.reduce((acc, d) => acc + (Number(d[campo]) || 0), 0);
    },

    // ── Autocomplete Diag ────────────────────────────────────────
    onDiag1Input() {
      this.filtroDiag1 = "";   // limpiar filtro activo al escribir
      this.showDiag1List = true;
      this.paginar(1);
    },
    onDiag2Input() {
      this.filtroDiag2 = "";
      this.showDiag2List = true;
      this.paginar(1);
    },
    seleccionarDiag1(v) {
      this.filtroDiag1Input = v;
      this.filtroDiag1      = v;
      this.showDiag1List    = false;
      this.paginar(1);
    },
    seleccionarDiag2(v) {
      this.filtroDiag2Input = v;
      this.filtroDiag2      = v;
      this.showDiag2List    = false;
      this.paginar(1);
    },
    limpiarDiag1() {
      this.filtroDiag1Input = "";
      this.filtroDiag1      = "";
      this.showDiag1List    = false;
      this.paginar(1);
    },
    limpiarDiag2() {
      this.filtroDiag2Input = "";
      this.filtroDiag2      = "";
      this.showDiag2List    = false;
      this.paginar(1);
    },
    hideDiagList(cual) {
      // Pequeño delay para que el @mousedown del item dispare antes del blur
      setTimeout(() => {
        if (cual === "diag1") this.showDiag1List = false;
        else                  this.showDiag2List = false;
      }, 150);
    },

    // ── Ordenamiento ─────────────────────────────────────────────
    ordenarPor(campo) {
      if (this.campoOrden === campo) {
        this.ascendente = !this.ascendente;
      } else {
        this.campoOrden = campo;
        this.ascendente = true;
      }
      this.paginar(1);
    },
    iconOrden(campo) {
      if (this.campoOrden !== campo) return "⇅";
      return this.ascendente ? "↑" : "↓";
    },

    // ── Formato monetario ─────────────────────────────────────────
    fmt(valor) {
      return new Intl.NumberFormat("es-EC", {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      }).format(valor || 0);
    },

    // ── Exportar Excel ────────────────────────────────────────────
    async exportarExcel() {
      try {
        Swal.fire({
          title: "Generando Excel...",
          text: "Por favor espera.",
          allowOutsideClick: false,
          showConfirmButton: false,
          didOpen: () => Swal.showLoading(),
        });
        const r = await api.get(
          `/planilla-resumen/${this.p_idtramite}/excel`,
          { responseType: "blob" }
        );
        Swal.close();
        const url  = URL.createObjectURL(new Blob([r.data]));
        const link = document.createElement("a");
        link.href     = url;
        link.download = `resumen_tramite_${this.p_idtramite}.xlsx`;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        URL.revokeObjectURL(url);
      } catch {
        Swal.fire({ icon: "error", title: "Error", text: "No se pudo generar el archivo Excel." });
      }
    },
  abrirPlanillaPopup(idPlanilla) {
    abrirPlanillaPopup(idPlanilla);
  },
  },
};
</script>

<style scoped>
/* ── Barra de acciones ───────────────────────────────────────── */
.action-bar {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 8px;
}
.action-btn {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 6px 14px;
  border: none;
  border-radius: 6px;
  font-size: 0.875rem;
  font-weight: 600;
  cursor: pointer;
  transition: filter .12s, transform .1s;
}
.action-btn:hover:not(:disabled) { filter: brightness(1.08); transform: translateY(-1px); }
.action-btn:disabled { opacity: .5; cursor: default; }
.action-btn .material-symbols-outlined { font-size: 18px; }
.action-btn--green { background: #198754; color: #fff; }

/* ── Tabla ───────────────────────────────────────────────────── */
.table-hover tbody tr { cursor: pointer; }

/* ── Breadcrumb ──────────────────────────────────────────────── */
.breadcrumb-item a       { color: #0d6efd; text-decoration: none; }
.breadcrumb-item a:hover { text-decoration: underline; }

/* ── Ordenamiento ────────────────────────────────────────────── */
.th-sort {
  cursor: pointer;
  user-select: none;
  white-space: nowrap;
}
.th-sort:hover { background-color: #3d5166; }
.sort-icon { font-size: 0.75rem; opacity: 0.8; }

/* ── Filtro de búsqueda ──────────────────────────────────────── */
.filter-input-wrap {
  position: relative;
  display: flex;
  align-items: center;
}
.filter-icon {
  position: absolute;
  left: 8px;
  font-size: 18px !important;
  color: #6c757d;
  pointer-events: none;
}
.filter-input {
  padding: 5px 32px 5px 32px;
  border: 1px solid #ced4da;
  border-radius: 6px;
  font-size: 0.875rem;
  width: 260px;
  outline: none;
  transition: border-color .15s, box-shadow .15s;
}
.filter-input:focus {
  border-color: #0d6efd;
  box-shadow: 0 0 0 3px rgba(13,110,253,.15);
}
.filter-clear {
  position: absolute;
  right: 6px;
  background: none;
  border: none;
  cursor: pointer;
  padding: 0;
  color: #6c757d;
  display: flex;
  align-items: center;
  transition: color .12s;
}
.filter-clear:hover { color: #dc3545; }

.diag-input { width: 110px; }

.diag-autocomplete-wrap {
  position: relative;
}

.diag-suggestions {
  position: absolute;
  top: calc(100% + 2px);
  left: 0;
  z-index: 1050;
  background: #fff;
  border: 1px solid #ced4da;
  border-radius: 6px;
  box-shadow: 0 4px 12px rgba(0,0,0,.12);
  list-style: none;
  margin: 0;
  padding: 4px 0;
  min-width: 130px;
  max-height: 220px;
  overflow-y: auto;
  scrollbar-width: thin;
  scrollbar-color: #adb5bd #f8f9fa;
}

.diag-suggestions li {
  padding: 6px 12px;
  font-size: 0.85rem;
  cursor: pointer;
  font-family: monospace;
  transition: background .1s;
}
.diag-suggestions li:hover  { background: #e8f0fe; }
.diag-suggestions li.diag-selected { background: #dbeafe; font-weight: 700; }
</style>